import React, { Component, useEffect, useState } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import { checkFirebaseToken } from "./firebase";
import { addFirebaseToken, deleteFirebaseToken, getTokenObject } from "./services/loginService";

const loading = (
   <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
   </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./login/Login"));
const FullStatus = React.lazy(() => import("./status/fullStatus"));
const Page404 = React.lazy(() => import("./pages/Page404"));
const Page500 = React.lazy(() => import("./pages/Page500"));

const App = () => {
   useEffect(() => {
      if (navigator.permissions && navigator.permissions.query) {
         navigator.permissions.query({ name: "notifications" }).then(async (status) => {
            await Notification.requestPermission();

            status.onchange = async () => {
               if (status?.state === "granted") {
                  //send fbtoken to server
                  let fbToken = await checkFirebaseToken();
                  await addFirebaseToken(fbToken);
               } else if (status?.state === "denied") {
                  //remove listener token server and local storage
                  await deleteFirebaseToken();
               }
               window.location.reload();
            };
         });
      }
   }, []);

   return (
      <HashRouter>
         <React.Suspense fallback={loading}>
            <Switch>
               <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />

               <Route path="/" name="Home" render={(props) => (getTokenObject() ? <TheLayout {...props} /> : <Login {...props} />)} />
            </Switch>
         </React.Suspense>
      </HashRouter>
   );
};

export default App;
